import { IComparisonObject, IMappingCondition, ISearchContext } from "./interfaces";

export const hasMatchingConditions = (
  condition: IMappingCondition,
  context: ISearchContext,
) => {
  const { propertyValueThreshold, ...mappingCondition } = condition;
  // eslint-disable-next-line  @typescript-eslint/no-unused-vars
  const { propertyValue, ...searchContext } = context;

  const shouldAssessPropertyValueGivenThreshold = searchContext.isFirstTimeBuyer
    && mappingCondition.isFirstTimeBuyer
    && propertyValueThreshold;

  if (shouldAssessPropertyValueGivenThreshold) {
    const { propertyValue } = context;
    const { propertyValueThreshold } = condition;

    if (propertyValue! > propertyValueThreshold!) {
      searchContext.overFirstTimeBuyerThreshold = true;
    } else {
      searchContext.overFirstTimeBuyerThreshold = false;
    }
  }

  if (Object.keys(mappingCondition).length !== Object.keys(searchContext).length) {
    return false;
  }

  return Object.keys(mappingCondition)
    .reduce((acc, conditionKey) => {
      if (!acc) {
        return acc;
      }
      if (
        searchContext[conditionKey as keyof IComparisonObject]
      !== mappingCondition[conditionKey as keyof IComparisonObject]) {
        return false;
      }
      return true;
    }, true);
};
